<template>
    <div class="container remove-padding-margin">
        <main class="add-padding-default">
            <div class="header-top bg-white">
                <div class="row justify-content-center align-items-center set-row w-limit">
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">
                        <img src="../../assets/img/x2.svg" data-toggle="modal" data-target="#modalOut">
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center">
                        <p>Login</p>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3">
                    </div>
                </div>
            </div>
            <div class="container w-limit">
            </div>
            <div class="conten-2 flex-100 w-limit">
                <div class="flex-1">
                    <div class="text-outlet full">
                        <h6>Kode verifikasi telah dikirim ke nomor <span>{{ telpNumber }}</span><b>, Periksa Whatsapp Anda</b> & silahkan masukkan kode.</h6>
                    </div>
                    <div class="contain-body">
                        <div class="input-code">
                            <div class="row justify-content-center align-items-center remove-padding-margin col-md-12 col-sm-12 col-12 col-lg-12 offset-lg-12">
                                <div class="col-md-12 remove-padding">
	                                <InputOtp :bindButton="'#btnVerifikasi'" @onComplete="setOtpCode" />
                                    <div class="col-12 remove-padding">
                                        <div class="code-otp text" id="textTimer">
                                            Kode Akan dikirim ulang dalam
	                                        <Countdown :timeleft="timeleft" @callbackCountdown="countdownTimeout"
	                                                   ref="countdown"/>
                                        </div>
                                        <div class="code-otp text" style="display: none" id="textTimer-loading">
                                            Kode sedang dikirim ...
                                        </div>
                                        <vue-recaptcha
                                                ref="recaptcha"
                                                @verify="onCaptchaVerified"
                                                @expired="onCaptchaExpired"
                                                size="invisible"
                                                sitekey="6Lc_X9QZAAAAAI0vmQNzNDQG-rKZ7NOE0O3wq5W9">
                                        </vue-recaptcha>
                                        <div class="code-otp text" id="linkKirimUlang">
                                            Tidak menerima kode ? <a style="color:#007bff" @click="submit">Kirim Ulang</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center footer mar-bottom-20">
                    <small class="powered">Nomor salah ?<a data-toggle="modal" data-target="#modalUbahNomor" style="color: #007bff">Ubah Nomor</a></small>
                </div>
                <div class="button-lanjut">
                    <button class="btn btn-login btn-long" id="btnVerifikasi" @click="sendVerificationCode">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked === true"></span>
                        <span id="textBtn">Verifikasi</span>
                    </button>
                </div>
            </div>
        </main>
        <div class="modal fade" id="modalUbahNomor" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Cek Nomor Anda</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <p>Kami telah beberapa kali mengirim kode OTP ke nomor {{ telpNumber }}. Apakah Anda
                            yakin ini nomor yang benar ?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long remove-margin" data-dismiss="modal"
                                @click="toLogin">Ubah Nomor
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modalOut" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Batalkan Login?</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <p>Apakah anda yakin ingin membatalkan proses login Smartlink owner ? </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                @click="toStartscreen">Ya, Batalkan
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VueRecaptcha from 'vue-recaptcha';
    import Countdown from "../../component-items/Countdown";
    import InputOtp from "../../component-items/InputOtp";
    
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
        history.go(1);
    };
    export default {
        name: 'Verifikasi',
        components: {
            'vue-recaptcha': VueRecaptcha,
	        'Countdown': Countdown,
	        'InputOtp': InputOtp,
        },
        data() {
            return {
                isClicked: false,
                timerData: "",
                telpNumber: "",
                nomorTelp: "",
                code_1: "",
                code_2: "",
                code_3: "",
                code_4: "",
                code_5: "",
                code_6: "",
                dataLoop: 1,
                timeHandler:null,
	            
	            timeleft: 0,
	            
	            otp: "",
            }
        },
        mounted() {
            $('#linkKirimUlang').hide();
            $('.first').focus();
            var telpLocal = "+" + localStorage.getItem("telp");
            this.telpNumber = telpLocal;
            this.nomorTelp = telpLocal;
            $('#close').hide()

            //initialisasi external script
            let recaptchaScriptVerifikasi = document.createElement('script')
            recaptchaScriptVerifikasi.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
            document.head.appendChild(recaptchaScriptVerifikasi)

	        $('body').on('DOMSubtreeModified', '.grecaptcha-badge', function(){
		        $(".grecaptcha-badge").hide()
	        });
            
            this.timeleft = 120;
        },
	    beforeDestroy() {
		    clearInterval(this.timeHandler)
	    },
	    methods: {
            submit() {
                $('#linkKirimUlang').hide();
                $('#textTimer').hide();
                $("#textTimer-loading").show()
                this.$refs.recaptcha.execute();
            },
            onCaptchaVerified: async function (recaptchaToken) {
                await this.getOTP(recaptchaToken)
                const self = this;
                self.$refs.recaptcha.reset();
            },
            onCaptchaExpired: function () {
                this.$refs.recaptcha.reset();
            },
            nextInputCode(event) {
                var nums = event.target.value;
                var number = nums.replace(/[^0-9]+/, '');
                event.target.value = number;
                if (this.code_1 != "" && this.code_2 != "" && this.code_3 != "" && this.code_4 != "" && this.code_5 != "" && this.code_6 != "") {
                    this.sendVerificationCode()
                    $('#btnVerifikasi').prop('disabled', true);
                } else {
                    if ((event.target.value.length == event.target.maxLength)&& number !== '') {
                        $(event.target).next('.inputs').focus();
                    }
                }
            },
            prevInputCode(event) {
                if (event.target.value === '') {
                    if (event.keyCode === 8) {
                        $(event.target).prev('.inputs').focus();
                        $('#btnVerifikasi').prop('disabled', true);
                    }
                }
            },
            closealert(){
                $('#alertInvalid').removeClass("alert alert-danger animated fadeInDown");
                $('#alertInvalid').addClass("alert alert-danger animated fadeOutUp");
            },
            toStartscreen() {
            	clearInterval(this.timeHandler)
                this.$router.push('/Startscreen')
            },
            toLogin() {
	            clearInterval(this.timeHandler)
                this.$router.push('/Login')
            },
            async getOTP(recaptchaToken) {
                $('#linkKirimUlang').hide();
                $('#textTimer').hide();
                $("#textTimer-loading").show()
                var loop = this.dataLoop + 1;
                this.dataLoop = loop;
                try {
                    var noTelp = localStorage.getItem("telp");
                    const dataotp = new FormData;
                    dataotp.append('telp',noTelp);
                    dataotp.append('token_captcha', recaptchaToken);
                    dataotp.append("tipe", "login")
                    const res = await this.$axios.post(this.$baseurl + '/auth/send_otp_with_captcha', dataotp)
	                if (!res.data.status) {
	                	this.$toast.error(res.data.msg)
		                this.$router.push("/login")
	                }
	
	                this.timeleft = 120;
                  $('#linkKirimUlang').hide();
                  $('#textTimer').show();
                  $("#textTimer-loading").hide()
                } catch (e) {
                	this.$catch_error_response(e)

                  $('#linkKirimUlang').show();
                  $('#textTimer').hide();
                  $("#textTimer-loading").hide()
                	
	                this.isClicked = false
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async sendVerificationCode() {
                $('#textBtn').hide();
                this.isClicked = true;
                // var kode = this.code_1 + '' + this.code_2 + '' + this.code_3 + '' + this.code_4 + '' + this.code_5 + '' + this.code_6;
                var kode = this.otp
	            var telpOtp = localStorage.getItem("telp");
                // $('#btnVerifikasi').prop('disabled', true);
                try {
                    const dataVerifikasi = new FormData;
                    dataVerifikasi.append('otp', kode);
                    dataVerifikasi.append('telp',telpOtp);

                    const forced = localStorage.getItem("forced");

                    dataVerifikasi.append('forced',forced);
                    const res = await this.$axios.post(this.$baseurl + '/auth/verifyotplogin', dataVerifikasi)
                    if(res.status===200) {
                        if (res.data.status === false) {
                        	this.$toast.error(res.data.msg)
	                        
                            this.isClicked = false
                            $('#textBtn').show();
                            $('#btnVerifikasi').prop('disabled', false);
                        } else {
                            var arrayData = res.data.data;
                            var lenghtData = arrayData.length;
                            var idowner = arrayData[0].idowner;
                            var superownerKey = arrayData[0].superowner.password;
                            $('#btnVerifikasi').text("Sedang cek akun anda");
                            if (lenghtData == 1) {
                                this.loginSingleAccount(telpOtp, idowner, superownerKey);
                            } else {
	                            localStorage.setItem("super_owner_key", res.data.data[0].superowner.password)
                                this.$router.push('/AkunLogin')
                            }
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	
	                this.isClicked = false
	                $('#textBtn').show();
	                $('#btnVerifikasi').prop('disabled', false);
                }
            },
            async loginSingleAccount(telp, idowner, superownerKey) {
                try {
                    const dataForm = new FormData;
                    const appUserAgent = navigator.userAgent
                    dataForm.append('user_agent', appUserAgent)
                    dataForm.append('idowner', idowner);
                    dataForm.append('telp',telp);
                    dataForm.append('super_owner_key',superownerKey);
                    const res = await this.$axios.post(this.$baseurl + '/auth/subakunsign', dataForm)
                    localStorage.setItem("token", res.data.data.token)
                    localStorage.setItem("idowner", res.data.data.idowner)
                    this.$router.push('/successlogin')
                } catch (e) {
                	this.$catch_error_response(e)
	
	                this.isClicked = false;
	                $('#textBtn').show();
	                $('#btnVerifikasi').prop('disabled', false);
                }
            },
		    setOtpCode(otp) {
            	this.otp = otp
			    
			    // direct
			    this.sendVerificationCode()
		    },
		    countdownTimeout() {
			    this.timeleft = 0;
       
			    if (this.dataLoop === 3) {
				    $('#modalUbahNomor').modal('show');
			    }

          $('#linkKirimUlang').show();
          $('#textTimer').hide();
          $("#textTimer-loading").hide()
		    },
        },
    }
</script>